import Header from '../components/Header'
import SearchBar from '../components/search/SearchBar'
import Footer from '../components/Footer'
import Cart from '../components/cart/Cart'

export default function CartPage () {
  return (
    <>
      <Header/>
      <SearchBar/>
      <Cart/>
      <Footer absolute={false}/>
    </>
  )
}